import { Localized } from "@fluent/react";

import styles from "./LoanEmptyState.module.scss";

interface LoanEmptyStateProps {
  titleId: string;
  titleFallback: string;
  descriptionId: string;
  descriptionFallback: string;
  onBack: () => void;
}

const LoanEmptyState = ({
  titleId,
  titleFallback,
  descriptionId,
  descriptionFallback,
  onBack,
}: LoanEmptyStateProps) => (
    <div className="transfer-page-layout">
      <div className="transfer-page">
        <div className={styles.container}>
          <h3 className={styles.title}>
            <Localized id={titleId}>{titleFallback}</Localized>
          </h3>
          <p className={styles.description}>
            <Localized id={descriptionId}>{descriptionFallback}</Localized>
          </p>
          <button onClick={onBack} className={styles.backButton}>
            <Localized id="button-back">Back</Localized>
          </button>
        </div>
      </div>
    </div>
  );

export default LoanEmptyState;
